import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { withRouter } from 'react-router-dom';
import { withApollo } from 'react-apollo';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
class TopbarCart extends Component {
  static propTypes = {
    new: PropTypes.bool
  };

  render() {
    let cartTotal = 0;
    const cartItems = this.props.cartItems;
    
    if (cartItems !== null && cartItems !== undefined) {
      cartItems.forEach((cartItem) => {
        cartTotal = cartTotal + cartItem.quantity
      })
    }

    return (
      <Link className='topbar__btn topbar__btn--mail'
        to='/app/marketplace/cart'>
        <span className='lnr lnr-cart' />
        <div>
          <span id="cart-total"> {cartTotal} </span>
        </div>
        <div className='topbar__btn-new-label'>
          Cart
        <div />
        </div>
      </Link>
    )
  }
}

function mapStateToProps(state) {
  return {
    cartItems:state.cartData.items
  }
}

export default withRouter(withApollo(connect(mapStateToProps)(TopbarCart)));


// WEBPACK FOOTER //
// ./src/pages/_layout/topbar/TopBarCart.js